export default __webpack_public_path__ + "static/media/annotation.28149b62.svg";